import React from "react";
import Popup from "reactjs-popup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import clientService from "../../services/client";

class DownloadPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.openInfoPopup,
      startDate: new Date(),
      endDate: new Date(),
      submitting: false,
    };
    this.closeInfoModal = this.closeInfoModal.bind(this);
  }

  closeInfoModal() {
    this.props.onChange(false);
  }

  handleChange(type, date) {
    this.setState({
      [type]: date,
    });
  }

  async exportData() {
    if (this.state.submitting) return;

    const fromDate = new Date(this.state.startDate);
    const toDate = new Date(this.state.endDate);
    const startDate = fromDate.toLocaleDateString("en-US");
    const endDate = toDate.toLocaleDateString("en-US");

    this.setState({ submitting: true });
    try {
      await clientService.requestLeadDownload(startDate, endDate);
      this.closeInfoModal();
      toast.success("Download job queued.");
      if (typeof this.props.onJobQueued === "function") {
        this.props.onJobQueued();
      }
    } catch (err) {
      console.error(err);
      toast.error(
        (err.response &&
          err.response.data &&
          err.response.data.message) ||
          "Failed to queue download job."
      );
    } finally {
      this.setState({ submitting: false });
    }
  }

  render() {
    const openInfoPopup = this.props.openInfoPopup.open;
    return (
      <div>
        <Popup
          open={openInfoPopup}
          onClose={this.closeInfoModal}
          closeOnDocumentClick
        >
          <div className="card">
            <div className="card-header">
              <h2>Download Leads</h2>
              <div className="card-options">
                <a
                  className="card-options-remove cursorPointer"
                  data-toggle="card-remove"
                  onClick={() => {
                    this.closeInfoModal();
                  }}
                >
                  <i className="fe fe-x"></i>
                </a>
              </div>
            </div>
            <div className="card-body">
              <div className="form-fieldset row ana-fliter">
                <div className="col col-6 col-sm-4 col-lg-4">
                  <label className="form-label">From Date</label>
                  <DatePicker
                    className="form-control"
                    selected={this.state.startDate}
                    onChange={(e) => this.handleChange("startDate", e)}
                    maxDate={this.state.endDate}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>

                <div className="col col-6 col-sm-4 col-lg-4">
                  <label className="form-label">To Date</label>
                  <DatePicker
                    className="form-control"
                    selected={this.state.endDate}
                    onChange={(e) => this.handleChange("endDate", e)}
                    minDate={this.state.startDate}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
                <div className="col col-6 col-sm-4 col-lg-4">
                  <label className="form-label">&nbsp;</label>
                  <button
                    className="btn btn-primary btn-block aligncentre"
                    type="submit"
                    disabled={this.state.submitting}
                    onClick={() => this.exportData()}
                  >
                    {this.state.submitting ? "Queuing..." : "Download"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Popup>
        <ToastContainer autoClose={5000} position={"bottom-right"} />
      </div>
    );
  }
}

export default DownloadPopup;
